import { defaultConfig, defineRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const menuLinkHoverBase = {
    borderLeftColor: 'secondary.300',
    textDecoration: 'none',
};

export const menuLinkStyle = {
    fontSize: 'sm',
    lineHeight: 1.5,
    py: 2,
    px: 4,
    color: 'secondary.600',
    width: '100%',
    border: 'none',
    borderLeft: '0.25rem solid',
    borderLeftColor: 'transparent',
    focusRingVisible: 'none',
    focusRing: 'none',

    _hover: {
        ...menuLinkHoverBase,
    },
};

export const linkRecipe = defineRecipe(
    merge(defaultConfig?.theme?.recipes?.link, {
        variants: {
            variant: {
                menuLinkBase: {
                    ...menuLinkStyle,
                    _hover: {
                        ...menuLinkStyle._hover,
                        bg: 'secondary.50',
                    },
                },
                menuLinkInner: {
                    ...menuLinkStyle,
                    bg: {
                        base: 'white',
                        md: 'secondary.50',
                    },
                    _hover: {
                        textDecoration: 'none',
                        bg: {
                            base: 'secondary.50',
                            md: 'white',
                        },
                        borderLeftColor: {
                            base: 'transparent',
                            md: 'secondary.300',
                        },
                    },
                    py: 1.5,
                },
                blendIn: {
                    color: 'inherit',
                    // No underline - even on hover
                },
            },
        },

        defaultVariants: {
            variant: 'underline',
        },
    }),
);
